import React from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
import { Link } from 'react-router-dom';
export function AngelikaSturnKinderJugendlichePage() {
  return <div className="min-h-screen bg-white" data-id="element-567">
      <Header data-id="element-568" />
      <main className="w-full pt-[152px]" data-id="element-569">
        <div className="w-full flex justify-center" data-id="element-570">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-571">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m1zQeZ3ZWVX754fhXCeb3d/Header-Kinder_Jugendliche-Angelika_Sturny.jpg" alt="Kinder und Jugendliche Header Bild" className="w-full h-full object-cover" data-id="element-572" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-573"></div>
            <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-574">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-575">
                <div className="max-w-lg text-left" data-id="element-576">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-577">
                    "Kinder brauchen nicht perfekte Eltern, sondern Menschen,
                    die sie lieben und an sie glauben."
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-578">– Jesper Juul</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-579">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-4" data-id="element-580">
            Systemische Therapie mit Kindern und Jugendlichen
          </h1>
          <h2 className="text-xl md:text-2xl font-light text-gray-600 mb-8" data-id="element-581">
            Entwicklung begleiten, Ressourcen stärken
          </h2>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-12" data-id="element-582">
            <p data-id="element-583">
              Kinder und Jugendliche entwickeln sich in einem komplexen
              Zusammenspiel aus inneren Prozessen und äußeren Einflüssen.
              Familie, Schule, Freundschaften und gesellschaftliche Erwartungen
              prägen ihr Erleben – und manchmal geraten sie dabei aus dem
              Gleichgewicht. Wenn sich Verhaltensauffälligkeiten zeigen,
              emotionale Belastungen zunehmen oder Konflikte im familiären
              Miteinander entstehen, kann eine systemische Beratung oder
              Familientherapie wertvolle Unterstützung bieten.
            </p>
          </div>
          <div className="mb-12 bg-blue-50 p-8 rounded-lg" data-id="element-584">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-585">
              Wann ist eine Beratung oder Familientherapie für Kinder und
              Jugendliche sinnvoll?
            </h3>
            <ul className="space-y-3 text-lg text-gray-700" data-id="element-586">
              <li className="flex items-start" data-id="element-587">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-588"></div>
                <span data-id="element-589">
                  Wenn Kinder oder Jugendliche sich verändern z. B. durch
                  Rückzug, Aggression, Ängste oder Schulprobleme
                </span>
              </li>
              <li className="flex items-start" data-id="element-590">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-591"></div>
                <span data-id="element-592">
                  Wenn Kommunikation innerhalb der Familie schwierig ist oder
                  häufig zu Konflikten führt
                </span>
              </li>
              <li className="flex items-start" data-id="element-593">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-594"></div>
                <span data-id="element-595">
                  Trennung der Eltern, Patchwork-Familien, Geschwisterkonflikte
                </span>
              </li>
              <li className="flex items-start" data-id="element-596">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-597"></div>
                <span data-id="element-598">Selbstwert, Identitätsfindung und Pubertät</span>
              </li>
              <li className="flex items-start" data-id="element-599">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-600"></div>
                <span data-id="element-601">
                  Wenn Eltern sich überfordert fühlen oder unterschiedliche
                  Vorstellungen von Erziehung haben
                </span>
              </li>
              <li className="flex items-start" data-id="element-602">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-603"></div>
                <span data-id="element-604">
                  Wenn das Bedürfnis besteht, Beziehungen zu klären und zu
                  stärken
                </span>
              </li>
            </ul>
          </div>
          <div className="mb-12 bg-gray-50 p-8 rounded-lg" data-id="element-605">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-606">
              Mein Angebot richtet sich an:
            </h3>
            <ul className="space-y-3 text-lg text-gray-600" data-id="element-607">
              <li className="flex items-start" data-id="element-608">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-609"></div>
                <span data-id="element-610">Kinder ab dem Vorschulalter</span>
              </li>
              <li className="flex items-start" data-id="element-611">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-612"></div>
                <span data-id="element-613">Jugendliche und junge Erwachsene</span>
              </li>
              <li className="flex items-start" data-id="element-614">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-615"></div>
                <span data-id="element-616">Eltern und Familien in belastenden Lebensphasen</span>
              </li>
            </ul>
          </div>
          <div className="mb-12" data-id="element-617">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-618">
              Was passiert in der systemischen Therapie mit Kindern und
              Jugendlichen?
            </h3>
            <ul className="space-y-3 text-lg text-gray-600" data-id="element-619">
              <li className="flex items-start" data-id="element-620">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-621"></div>
                <span data-id="element-622">
                  Die Therapie beginnt mit einem gemeinsamen Kennenlernen – oft
                  mit den Eltern oder Bezugspersonen. Dabei klären wir, welche
                  Themen im Vordergrund stehen und was sich verändern soll. Je
                  nach Alter und Anliegen arbeite ich mit dem Kind oder
                  Jugendlichen allein, im Wechsel mit den Eltern oder in
                  gemeinsamen Gesprächen.
                </span>
              </li>
              <li className="flex items-start" data-id="element-623">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-624"></div>
                <span data-id="element-625">
                  Die Methoden sind altersgerecht und kreativ wie beispielsweise
                  Gespräche, spielerische Elemente,{' '}
                  <Link to="/angelika_sturny/familientherapie#genogrammarbeit" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-626">
                    Genogrammarbeit
                  </Link>
                  , aber auch Ressourcenkarten, Visualisierungen oder
                  systemische Fragetechniken helfen innere Prozesse sichtbar zu
                  machen und neue Perspektiven zu entwickeln.
                </span>
              </li>
            </ul>
          </div>
          <div className="mb-12" data-id="element-627">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-628">
              Ziele der gemeinsamen Arbeit:
            </h3>
            <ul className="space-y-3 text-lg text-gray-600" data-id="element-629">
              <li className="flex items-start" data-id="element-630">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-631"></div>
                <span data-id="element-632">Verstehen, was hinter dem Verhalten steht</span>
              </li>
              <li className="flex items-start" data-id="element-633">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-634"></div>
                <span data-id="element-635">
                  Stärken, was trägt: Vertrauen, Kommunikation, gegenseitige
                  Wertschätzung
                </span>
              </li>
              <li className="flex items-start" data-id="element-636">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-637"></div>
                <span data-id="element-638">
                  Verändern, was belastet: Konfliktdynamiken, Missverständnisse,
                  Überforderungen
                </span>
              </li>
              <li className="flex items-start" data-id="element-639">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-640"></div>
                <span data-id="element-641">
                  Wachsen – als Familie, in der jeder Einzelne gehört und
                  gesehen wird
                </span>
              </li>
            </ul>
          </div>
          <div className="mb-12" data-id="element-642">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-643">
              Meine Arbeitsweise:
            </h3>
            <div className="text-lg text-gray-600 leading-relaxed" data-id="element-644">
              <p data-id="element-645">
                Ich arbeite systemisch, ressourcenorientiert und altersgerecht –
                mit kreativen Methoden, Gesprächen, Spielen, Bildern und
                Übungen, die Kindern und Jugendlichen helfen, sich auszudrücken
                und verstanden zu fühlen. Die Eltern werden je nach Anliegen
                aktiv in den Prozess einbezogen. Ziel ist es, nicht nur Symptome
                zu behandeln, sondern die dahinterliegenden Dynamiken zu
                verstehen und gemeinsam neue Lösungswege zu entwickeln.
              </p>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-646">
            <p className="text-gray-600 mb-4" data-id="element-647">
              Die Rahmenbedingungen wie Terminvereinbarung, Ablauf und Kosten
              finden Sie unter{' '}
              <Link to="/angelika_sturny/info" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-648">
                Info
              </Link>
              .
            </p>
            <p className="text-gray-600" data-id="element-649">
              Appointments are also possible in English. Please contact me via{' '}
              <a href="mailto:praxis@angelikasturny.com" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-650">
                email
              </a>{' '}
              for sessions in English!
            </p>
          </div>
        </div>
      </main>
      <AngelikaSturnFooter data-id="element-651" />
    </div>;
}